import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const Label = styled.div<IWithSize>`
  font-family: Montserrat;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: ${({ fw }) => (fw ? fw : 300)};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.1px;
  text-align: center;
  white-space: nowrap;
`
export default Label
